import React from 'react'
import { string, shape, object } from 'prop-types'
import styles from './SpeakerThumbnail.module.scss'
import Type from '@/component/Primitive/Type'
import ResponsiveImage from '@/component/Primitive/ResponsiveImage'
import cx from 'classnames'

export const SpeakerThumbnail = ({
  image,
  images,
  name,
  jobTitle,
  companyName,
  className,
  classNames
}) => {
  if (!image && images) {
    const getImage = (imageList, context, ratio, size) =>
      imageList?.[`${context}_${ratio}_${size}`]?.[0]

    image = {
      alt: 'Event Image Placeholder',
      sizes: ['min-width(960px) 50vw', '100vw'],
      src: getImage(images, 'speaker', '1x1', 320)?.url
    }
  }
  return (
    <div className={cx(styles.SpeakerThumbnail, className)}>
      {image && (
        <div className={styles.SpeakerThumbnailImageWrapper}>
          <ResponsiveImage className={styles.SpeakerThumbailImage} {...image} />
        </div>
      )}
      <div className={styles.SpeakerThumbnailContent}>
        <Type
          as="h3"
          size="body2"
          weight="medium"
          classNames={classNames?.name}
        >
          {name}
        </Type>
        <Type
          as="p"
          size="body4"
          className={cx(styles.SpeakerThumbnailJobTitle, classNames?.jobTitle)}
        >
          {jobTitle}, {companyName}
        </Type>
      </div>
    </div>
  )
}

SpeakerThumbnail.propTypes = {
  image: string,
  images: object,
  name: string,
  jobTitle: string,
  companyName: string,
  className: string,
  classNames: shape({
    name: string,
    jobTitle: string
  })
}
